/* DataCenterCompatModal.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import Button from '@atlaskit/button/standard-button';
import Modal, { ModalFooter, ModalTransition } from '@atlaskit/modal-dialog';
import { ExternalLink } from '@atlassian/mpac-ui';
import React from 'react';
import { ANALYTICS_EVENT_SOURCE_CONTACT_PARTNER_DATA_CENTER } from '../../../analytics/Events';
import DataCenterGraphicSVG from './data-center-graphic.svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const heroImgOffset = 45;
const styles = {
  dataCenterHero: null,
  dataCenterHeroImg: null,
  modalContent: null,
  h2: null,
  p: null,
  h3: null,
  customModalBody: null
};
export default function DataCenterCompatModal(props) {
  return /*#__PURE__*/_jsx(ModalTransition, {
    children: props.isOpen && /*#__PURE__*/_jsxs(Modal, {
      onClose: props.onClose,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.customModalBody,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.dataCenterHero,
          children: /*#__PURE__*/_jsx("img", {
            alt: "data center icon graphic",
            src: DataCenterGraphicSVG,
            className: styles.dataCenterHeroImg
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.modalContent,
          children: [/*#__PURE__*/_jsx("h2", {
            className: styles.h2,
            children: "Data Center compatibility"
          }), /*#__PURE__*/_jsx("p", {
            className: styles.p,
            children: "A Data Center approved version of this app is not currently available. Only apps meeting a set of performance requirements for large, clustered environments are approved for Data Center."
          }), /*#__PURE__*/_jsx("h3", {
            className: styles.h3,
            children: "Trying server apps"
          }), /*#__PURE__*/_jsxs("p", {
            className: styles.p,
            children: ["While Server apps are built for single-server deployments, many customers successfully install them in Data Center environments. Atlassian recommends you", ' ', props.partnerSupportUrl ? /*#__PURE__*/_jsx(ExternalLink, {
              href: props.partnerSupportUrl,
              onClick: () => {
                var _props$onContactPartn;
                return (_props$onContactPartn = props.onContactPartnerClick) === null || _props$onContactPartn === void 0 ? void 0 : _props$onContactPartn.call(props, ANALYTICS_EVENT_SOURCE_CONTACT_PARTNER_DATA_CENTER);
              },
              children: "contact the vendor"
            }) : 'contact the vendor', ' ', "to determine compatibility at scale."]
          })]
        })]
      }), /*#__PURE__*/_jsx(ModalFooter, {
        children: /*#__PURE__*/_jsx(Button, {
          appearance: "primary",
          onClick: props.onClose,
          children: "Dismiss"
        })
      })]
    })
  });
}